import { tokenService } from 'src/services';
import Services from 'src/services/Services';

// requestAsAdminResult: "3" sonuçlanmamış (beklemede / hiç talep yok), "0" reddedildi
const PENDING_RESULT = '3';
const REJECTED_RESULT = '0';

export const REQUEST_AS_ADMIN_STATUS = {
  NONE: 'none',
  PENDING: 'pending',
  REJECTED: 'rejected',
};

const toBoolean = (value) =>
  value === true || value === 1 || value === '1' || value === 'true';

export const getRequestAsAdminStatus = (user) => {
  if (!toBoolean(user?.requestAsAdmin)) return REQUEST_AS_ADMIN_STATUS.NONE;

  const result = String(user?.requestAsAdminResult);
  if (result === PENDING_RESULT) return REQUEST_AS_ADMIN_STATUS.PENDING;
  if (result === REJECTED_RESULT) return REQUEST_AS_ADMIN_STATUS.REJECTED;
  return REQUEST_AS_ADMIN_STATUS.NONE;
};

// get-profile snake_case döner; login datasındaki camelCase alanlara çevirip
// sadece talep alanlarını günceller
export const mergeRequestAsAdminFromProfile = (user, profile) => {
  if (!user || !profile) return user;

  const resultDateTime =
    profile.request_as_admin_confirmed_date_time ??
    profile.request_as_admin_rejected_date_time ??
    null;

  return {
    ...user,
    requestAsAdmin:
      profile.request_as_admin !== undefined
        ? toBoolean(profile.request_as_admin)
        : user.requestAsAdmin,
    requestAsAdminResult:
      profile.request_as_admin_result ?? user.requestAsAdminResult,
    requestAsAdminResultDateTime: resultDateTime ?? false,
  };
};

// Hata durumunda localStorage'daki mevcut user döner
export const refreshRequestAsAdminStatus = async () => {
  const user = tokenService.getUser();
  if (!user?.token) return user;

  try {
    const response = await Services.GetProfile(user.token);
    if (!response?.data?.status) return user;

    const updatedUser = mergeRequestAsAdminFromProfile(
      user,
      response.data.result
    );
    localStorage.setItem('user', JSON.stringify(updatedUser));
    return updatedUser;
  } catch (error) {
    return user;
  }
};
